import type { Application } from "@ark/contracts";
import { useQuery } from "@tanstack/react-query";

import { sessionManager, useSession } from "./session";

// applicationsQueryKey 是可见应用列表的共享 react-query key，
// 供侧边栏菜单、应用中心卡片与远程宿主共用同一份缓存。
export const applicationsQueryKey = ["applications", "visible"] as const;

export function applicationVisibilityQueryKey(
  tenantId: string,
  userId: string,
) {
  return [...applicationsQueryKey, tenantId, userId] as const;
}

// useApplications 拉当前用户可见的应用（active + scope 过滤）。
// 登录后各处（菜单 / 卡片 / 远程宿主）复用同一缓存，避免重复请求。
export function useApplications() {
  const session = useSession();
  const tenantId = session?.tenant.id ?? "";
  const userId = session?.user.id ?? "";
  return useQuery<Application[]>({
    enabled: Boolean(session),
    queryKey: applicationVisibilityQueryKey(tenantId, userId),
    queryFn: ({ signal }) =>
      sessionManager.listApplications(signal, { tenantId, userId }),
    staleTime: 60_000,
    retry: false,
  });
}
